<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- ── Breadcrumb ─────────────────────────────────────────────── -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <router-link to="/tramite-carga">Trámites</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="'/tramiteform-carga/' + p_idTramite">
                  Trámite {{ p_idTramite }}
                </router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Carga {{ p_idCarga }}
              </li>
            </ol>
          </nav>
        </div>
        <div class="col-1 text-end">
          <span
            class="material-symbols-outlined text-primary"
            style="font-size: 28px; cursor: pointer"
            @click="showModalHelp = true"
            title="Ayuda"
          >help</span>
        </div>
      </div>
    </div>

    <hr />

    <!-- ── Tabs ───────────────────────────────────────────────────── -->
    <ul class="nav nav-tabs mb-0" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link d-flex align-items-center gap-1"
          :class="{ active: tabActiva === 'errores' }"
          @click="tabActiva = 'errores'"
          type="button" role="tab"
        >
          <span class="material-symbols-outlined" style="font-size:16px">error</span>
          Errores
          <span v-if="cargaplanillasErrores.length" class="badge bg-danger ms-1">
            {{ cargaplanillasErrores.length }}
          </span>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link d-flex align-items-center gap-1"
          :class="{ active: tabActiva === 'novedades' }"
          @click="tabActiva = 'novedades'"
          type="button" role="tab"
        >
          <span class="material-symbols-outlined" style="font-size:16px">new_releases</span>
          Novedades
          <span v-if="cargaplanillasNovedades.length" class="badge bg-warning text-dark ms-1">
            {{ cargaplanillasNovedades.length }}
          </span>
        </button>
      </li>
    </ul>

    <!-- ── Barra de exportación ───────────────────────────────────── -->
    <div class="export-bar">
      <button class="action-btn action-btn--green" @click="exportToCSV" title="Exportar a CSV">
        <span class="material-symbols-outlined">download</span>
        CSV
      </button>
      <button class="action-btn action-btn--red" @click="exportToPDF" title="Exportar a PDF">
        <span class="material-symbols-outlined">picture_as_pdf</span>
        PDF
      </button>
      <button class="action-btn action-btn--blue" @click="printTable" title="Imprimir">
        <span class="material-symbols-outlined">print</span>
        Imprimir
      </button>

      <!-- Selector de registros por página -->
      <div class="ms-auto d-flex align-items-center gap-2">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select
          v-model.number="elementosPorPagina"
          class="form-select form-select-sm"
          style="width: 75px;"
          @change="recargarPaginacion"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>
    </div>

    <!-- ── Contenido de tabs ──────────────────────────────────────── -->
    <div class="tab-content">

      <!-- Errores -->
      <div
        class="tab-pane fade"
        :class="{ 'show active': tabActiva === 'errores' }"
        id="errores" role="tabpanel"
      >
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-sm" id="erroresTable">
            <thead class="table-dark">
              <tr>
                <th>Número</th>
                <th>Cédula</th>
                <th>Nombre</th>
                <th>Errores</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="cp in datosPaginadosErrores"
                :key="cp.idCargaPlanilla"
                class="align-top"
              >
                <td>{{ cp.numero }}</td>
                <td>{{ cp.cedula }}</td>
                <td>{{ cp.nombre }}</td>
                <td><span v-html="cp.detalleErrores"></span></td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-secondary">
                <td colspan="4" class="text-end fw-bold small">
                  Mostrando {{ datosPaginadosErrores.length }} de {{ cargaplanillasErrores.length }} registros
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <Paginacion
          :pagina-actual="paginaActualErrores"
          :total-paginas="totalPaginas('errores')"
          @primera="irPrimeraPagina('errores')"
          @anterior="getPreviousPage('errores')"
          @siguiente="getNextPage('errores')"
          @ultima="irUltimaPagina('errores')"
        />
      </div>

      <!-- Novedades -->
      <div
        class="tab-pane fade"
        :class="{ 'show active': tabActiva === 'novedades' }"
        id="novedades" role="tabpanel"
      >
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-sm" id="novedadesTable">
            <thead class="table-dark">
              <tr>
                <th>Número</th>
                <th>Cédula</th>
                <th>Nombre</th>
                <th>Novedades</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="cp in datosPaginadosNovedades"
                :key="cp.idCargaPlanilla"
                class="align-top"
              >
                <td>{{ cp.numero }}</td>
                <td>{{ cp.cedula }}</td>
                <td>{{ cp.nombre }}</td>
                <td><span v-html="cp.detalleNovedades"></span></td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-secondary">
                <td colspan="4" class="text-end fw-bold small">
                  Mostrando {{ datosPaginadosNovedades.length }} de {{ cargaplanillasNovedades.length }} registros
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <Paginacion
          :pagina-actual="paginaActualNovedades"
          :total-paginas="totalPaginas('novedades')"
          @primera="irPrimeraPagina('novedades')"
          @anterior="getPreviousPage('novedades')"
          @siguiente="getNextPage('novedades')"
          @ultima="irUltimaPagina('novedades')"
        />
      </div>

    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ── Subcomponente de paginación reutilizable ──────────────────
const Paginacion = {
  props: {
    paginaActual:  { type: Number, required: true },
    totalPaginas:  { type: Number, required: true },
  },
  emits: ["primera", "anterior", "siguiente", "ultima"],
  template: `
    <div class="d-flex justify-content-between align-items-center mt-2 mb-3">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas }}
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="$emit('primera')">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="$emit('anterior')">‹</a>
          </li>
          <li class="page-item active">
            <span class="page-link">{{ paginaActual }}</span>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
            <a class="page-link" href="#" @click.prevent="$emit('siguiente')">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
            <a class="page-link" href="#" @click.prevent="$emit('ultima')">»</a>
          </li>
        </ul>
      </nav>
    </div>
  `,
};

export default {
  components: { Layout, Footer, Paginacion },

  data() {
    return {
      cargaplanillasErrores:   [],
      cargaplanillasNovedades: [],
      elementosPorPagina:      10,
      datosPaginadosErrores:   [],
      datosPaginadosNovedades: [],
      paginaActualErrores:     1,
      paginaActualNovedades:   1,
      p_idTramite:             0,
      p_idCarga:               0,
      tabActiva:               "errores",
      showModalHelp:           false,
    };
  },

  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idCarga   = this.$route.params.p_idcarga;
    this.cargarDatosErrores();
    this.cargarDatosNovedades();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },

  methods: {
    // ── Helpers de paginación ─────────────────────────────────────
    paginaKey(tab)  { return tab === "errores" ? "paginaActualErrores"   : "paginaActualNovedades"; },
    datosKey(tab)   { return tab === "errores" ? "datosPaginadosErrores" : "datosPaginadosNovedades"; },
    datosTab(tab)   { return tab === "errores" ? this.cargaplanillasErrores : this.cargaplanillasNovedades; },

    totalPaginas(tab) {
      return Math.max(1, Math.ceil(this.datosTab(tab).length / this.elementosPorPagina));
    },
    getDataPagina(tab, noPagina) {
      this[this.paginaKey(tab)] = noPagina;
      const ini = (noPagina - 1) * this.elementosPorPagina;
      this[this.datosKey(tab)] = this.datosTab(tab).slice(ini, ini + this.elementosPorPagina);
    },
    getPreviousPage(tab) {
      if (this[this.paginaKey(tab)] > 1) this.getDataPagina(tab, this[this.paginaKey(tab)] - 1);
    },
    getNextPage(tab) {
      if (this[this.paginaKey(tab)] < this.totalPaginas(tab)) this.getDataPagina(tab, this[this.paginaKey(tab)] + 1);
    },
    irPrimeraPagina(tab) { this.getDataPagina(tab, 1); },
    irUltimaPagina(tab)  { this.getDataPagina(tab, this.totalPaginas(tab)); },
    recargarPaginacion() {
      this.getDataPagina("errores",   this.paginaActualErrores);
      this.getDataPagina("novedades", this.paginaActualNovedades);
    },

    // ── Carga de datos ────────────────────────────────────────────
    cargarDatosErrores() {
      api.get(`/vwcargaplanillas/errores/${this.p_idTramite}/${this.p_idCarga}`)
        .then((r) => {
          this.cargaplanillasErrores = r.data;
          this.getDataPagina("errores", 1);
        })
        .catch((e) => console.error("Error al cargar errores:", e));
    },
    cargarDatosNovedades() {
      api.get(`/vwcargaplanillas/novedades/${this.p_idTramite}/${this.p_idCarga}`)
        .then((r) => {
          this.cargaplanillasNovedades = r.data;
          this.getDataPagina("novedades", 1);
        })
        .catch((e) => console.error("Error al cargar novedades:", e));
    },

    // ── Exportación ───────────────────────────────────────────────
    stripHtml(html) { return (html || "").replace(/<\/?[^>]+(>|$)/g, ""); },

    exportToCSV() {
      const datos = this.tabActiva === "errores" ? this.cargaplanillasErrores : this.cargaplanillasNovedades;
      const campo = this.tabActiva === "errores" ? "detalleErrores" : "detalleNovedades";
      const header = `Número;Cédula;Nombre;${this.tabActiva === "errores" ? "Errores" : "Novedades"}\n`;
      const rows   = datos.map((cp) =>
        `${cp.numero};${cp.cedula};${cp.nombre};"${this.stripHtml(cp[campo])}"`
      ).join("\n");
      const link = document.createElement("a");
      link.setAttribute("href", encodeURI("data:text/csv;charset=utf-8," + header + rows));
      link.setAttribute("download", `carga_${this.p_idCarga}_${this.tabActiva}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    exportToPDF() {
      const datos  = this.tabActiva === "errores" ? this.cargaplanillasErrores : this.cargaplanillasNovedades;
      const campo  = this.tabActiva === "errores" ? "detalleErrores" : "detalleNovedades";
      const colLbl = this.tabActiva === "errores" ? "Errores" : "Novedades";
      const doc    = new jsPDF();
      autoTable(doc, {
        startY: 20,
        head: [["Número", "Cédula", "Nombre", colLbl]],
        body: datos.map((cp) => [cp.numero, cp.cedula, cp.nombre, this.stripHtml(cp[campo])]),
      });
      doc.save(`carga_${this.p_idCarga}_${this.tabActiva}.pdf`);
    },

    printTable() {
      const tableId = this.tabActiva === "errores" ? "erroresTable" : "novedadesTable";
      const win = window.open("", "", "height=600,width=800");
      win.document.write(`
        <html><head><title>Imprimir</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        </head><body>${document.getElementById(tableId).outerHTML}</body></html>
      `);
      win.document.close();
      win.print();
    },
  },
};
</script>

<style scoped>
/* ── Barra de exportación ────────────────────────────────────── */
.export-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0;
  background: #f8f9fa;
  padding-left: 4px;
  padding-right: 4px;
}

/* ── Botones de acción ───────────────────────────────────────── */
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 13px;
  border: none;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: filter .12s, transform .1s;
}
.action-btn:hover { filter: brightness(1.08); transform: translateY(-1px); }
.action-btn .material-symbols-outlined { font-size: 16px; }
.action-btn--green { background: #198754; color: #fff; }
.action-btn--red   { background: #dc3545; color: #fff; }
.action-btn--blue  { background: #0d6efd; color: #fff; }

/* ── Tabla ───────────────────────────────────────────────────── */
.table-hover tbody tr { cursor: default; }
.align-top td { vertical-align: top; }

/* ── Breadcrumb ──────────────────────────────────────────────── */
.breadcrumb-item a {
  color: #0d6efd;
  text-decoration: none;
}
.breadcrumb-item a:hover { text-decoration: underline; }
</style>